import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { Spin, Tag } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { Article } from '../../../../../hooks/api/articles';
import { IconArrowLeft } from '../../../../Common/Icon';
import { formatDate } from '../../../../../utils';
import VideoWithThumbnail from '../VideoWithThumbnail';
import DisplayHtmlContent from '../../../../Common/DisplayHtmlContent';
import ShareButton from '../../../../Common/ShareButton';
import Questionnaire from '../Questionnaire';
import Comments from '../../../../Common/Comments';
import MostRecent from '../MostRecent';
import JoinOurCommunity from '../../JoinOurCommunity';

import styles from '../../index.module.scss';
import { useEffect, useState } from 'react';

/* const socialLinks = [
  { href: 'https://facebook.com', Icon: Facebook, label: 'Facebook' },
  { href: 'https://instagram.com', Icon: Instagram, label: 'Instagram' },
  { href: 'https://linkedin.com', Icon: Linkedin, label: 'Linkedin' },
  { href: 'https://twitter.com', Icon: Twitter, label: 'Twitter' },
]; */

interface ArticleContentProps {
  data: Article | undefined;
  loading: boolean;
  id: string | undefined;
  simplified?: boolean;
}

function ViewContent({ data, loading, id, simplified }: ArticleContentProps) {
  const navigate = useNavigate();
  const isTablet = useMediaQuery({
    query: '(max-width: 1024px)',
  });
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (data?.articleType === 'blog') {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [data]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.viewItems}>
          <div className={styles.itemContent}>
            <div
              role="button"
              onClick={show ? () => navigate('/tipping-articles') : undefined}
              tabIndex={show ? -1 : undefined}
              className={isTablet ? styles.backBtnMobile : styles.backBtn}
              style={{
                visibility: show ? 'visible' : 'hidden',
              }}
            >
              <IconArrowLeft />
              All Articles
            </div>
            <div className={styles.item}>
              <div className={styles.itemHeader}>
                <div className={styles.title}>
                  {!simplified && data?.createdAt && show ? (
                    <div>
                      <span style={{ color: '#00000066' }}>
                        {formatDate(data.createdAt)}
                      </span>
                    </div>
                  ) : null}
                  {data?.name ? (
                    <h2 style={{ textAlign: 'center' }}>{data.name}</h2>
                  ) : null}
                  {data?.tags ? (
                    <div>
                      {data?.tags.map((tag) => (
                        <Tag key={tag.id}>{tag.name}</Tag>
                      ))}
                    </div>
                  ) : null}
                </div>
                {data?.file ? (
                  <VideoWithThumbnail
                    thumbnail={data.file}
                    video={data.video}
                  />
                ) : (
                  /* <div className={styles.imgContainer}>
                      <img src={data.file.location} alt="" />
                    </div> */
                  <div className={styles.imgContainer} style={{ height: 40 }}>
                    <div
                      role="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate('/tipping-articles');
                      }}
                      tabIndex={-1}
                      className={styles.backBtnMobile}
                      style={!isTablet ? { display: 'none' } : {}}
                    >
                      <IconArrowLeft />
                      All Articles
                    </div>
                  </div>
                )}
              </div>
              {data?.description ? (
                <div className={styles.text}>
                  <DisplayHtmlContent html={data.description} />
                </div>
              ) : null}

              {!simplified && show && (
                <div className={styles.author}>
                  {data?.authorImage ? (
                    <img
                      src={data?.authorImage.location}
                      alt="author-logo"
                      className={styles.authorLogo}
                    />
                  ) : (
                    <UserOutlined className={styles.authorLogo} />
                  )}
                  <div>
                    <h4>Written by {data?.authorName || '-'}</h4>
                    <span>{data?.authorDescription || '-'}</span>
                  </div>
                </div>
              )}
              {!simplified && (
                <div className={styles.shareSocial}>
                  <ShareButton label={show ? 'Share article' : 'Share'} />

                  {/* <h4>Share Article</h4>
                <div>
                  {socialLinks.map(({ href, Icon, label }) => (
                    <a
                      key={href}
                      href={href}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={label}
                      style={{ textDecoration: 'none', color: '#282C35' }}
                    >
                      <Icon />
                    </a>
                  ))}
                </div> */}
                </div>
              )}
              {!simplified && show && (
                <div className={styles.questionnaire}>
                  <Questionnaire id={id} />
                </div>
              )}

              {show && (
                <div style={{ marginTop: 20 }}>
                  <Comments filter={{ article: id, entity: 'article' }} />
                </div>
              )}
            </div>
          </div>
          {simplified && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <h2>Most Recent Articles</h2>
              <MostRecent />
            </div>
          )}
        </div>
      </div>
      {loading ? (
        <div className="spin">
          <Spin />
        </div>
      ) : null}
      <JoinOurCommunity />
    </div>
  );
}

export default ViewContent;
